var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.824937,
    y: 0.15825,
    width: 23.0168,
    height: 15.6835,
    rx: 1.74075,
    fill: "white",
    stroke: "#F6F6F4",
    strokeWidth: 0.3165
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4649 11.5873C11.6705 12.2728 10.6401 12.6866 9.51412 12.6866C7.00167 12.6866 4.96494 10.6262 4.96494 8.08463C4.96494 5.54302 7.00167 3.48264 9.51412 3.48264C10.6401 3.48264 11.6705 3.89647 12.4649 4.58198C13.2593 3.89648 14.2897 3.48265 15.4157 3.48265C17.9282 3.48265 19.9649 5.54303 19.9649 8.08464C19.9649 10.6262 17.9282 12.6866 15.4157 12.6866C14.2897 12.6866 13.2593 12.2728 12.4649 11.5873Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4649 11.5873C13.443 10.7432 14.0633 9.48719 14.0633 8.08464C14.0633 6.68209 13.443 5.42609 12.4649 4.582C13.2593 3.89648 14.2897 3.48265 15.4157 3.48265C17.9282 3.48265 19.9649 5.54303 19.9649 8.08464C19.9649 10.6263 17.9282 12.6866 15.4157 12.6866C14.2897 12.6866 13.2593 12.2728 12.4649 11.5873Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4649 11.5873C13.4431 10.7432 14.0633 9.48718 14.0633 8.08464C14.0633 6.6821 13.4431 5.42611 12.4649 4.58202C11.4868 5.42611 10.8666 6.6821 10.8666 8.08464C10.8666 9.48718 11.4868 10.7432 12.4649 11.5873Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.911784cbab86897c0ce0c47b960af81e.svg";
export { ForwardRef as ReactComponent };